/* VIP Sale 2026 – Core (T0). Stellt window.VIP bereit; liest nur window.VIP_CONFIG (snippets/vip-config.liquid).
   Alle Feature-Skripte (vip-banner.js, vip-gift.js, vip-delivery.js, vip-savecart.js) bauen hierauf auf.

   API (window.VIP):
     VIP.config                 -> window.VIP_CONFIG
     VIP.now()                  -> Date (inkl. Phasen-Simulation)
     VIP.phase()                -> aktuelle Phase {key,label,code,start,end,password_only,gift,tiers,active,startAt,endAt,untilAt}
                                   außerhalb des Sales: {key:'pre'|'post', active:false, ...}
     VIP.tiers()                -> tiers[] der aktuellen Phase ([] außerhalb)
     VIP.tierFor(subtotalCents) -> {min,pct} der aktuellen Phase für diesen Warenwert (Cent) oder null
     VIP.nextTierFor(cents)     -> nächsthöhere Stufe {min,pct,missingCents} oder null
     VIP.nextSwitchAt()         -> Date des nächsten Phasenwechsels (Start der nächsten Phase bzw. Ende der letzten) oder null
     VIP.cartBasisCents(cart)   -> Warenwert VOR Rabatt in Cent (ohne Gratis-Teppich-Zeile _vip_gift)
     VIP.formatEUR(cents)       -> "1.234,56 €"
     VIP.cart                   -> zuletzt bekannter Warenkorb (cart.js-JSON) oder null
     VIP.refreshCart()          -> Promise<cart>; lädt /cart.js und feuert vip:cart
     VIP.rerender(opts)         -> Promise<cart>; rendert Warenkorb-Drawer + Warenkorb-Seite des Themes neu
     VIP.updateCart(payload)    -> Promise<cart>; POST /cart/update.js (attributes, note, updates) + Re-Render
     VIP.changeLine(payload)    -> Promise<cart>; POST /cart/change.js ({id|line, quantity, properties}) + Re-Render
     VIP.addItems(payload, {open}) -> Promise<cart>; POST /cart/add.js ({items:[...]}) + Re-Render (open: Drawer öffnen)
     VIP.onPhase(fn) / VIP.onCart(fn) -> Abo auf die Events, fn wird sofort mit dem aktuellen Stand aufgerufen
     VIP.simulate(key|null)     -> Simulation setzen (nur theme.role != 'main'), key: pre|early|vipday|day2|day3|post
     VIP.simulated              -> aktueller Simulations-Key oder null

   Events (document):
     'vip:phase'  detail {phase, previous, simulated}      – beim Start und bei jedem Phasenwechsel
     'vip:cart'   detail {cart, basisCents, tier, source}   – bei jeder Warenkorb-Änderung (nach Re-Render des Themes)

   Phasen-Auswertung (B1-Fix 19.10.): Phasen sind LÜCKENLOS. Eine Phase gilt von ihrem start (inklusive) bis zum
   start der nächsten Phase (exklusiv, Feld untilAt); die letzte Phase bis zu ihrem end (Sekunde inklusive).
   Die end-Werte der Config (…:00:59Z) bleiben unverändert und dienen nur der Anzeige. Ein Phasenwechsel wird erst
   gemeldet, wenn die neue Phase >= 1,5 s stabil ist (Debounce gegen Jitter); die erste Auswertung beim Laden sofort.

   Warenkorb-Erkennung: fetch + XMLHttpRequest auf /cart/add.js, /cart/change.js, /cart/update.js,
   /cart/clear.js und /cart.js werden abgefangen; zusätzlich Theme-Events 'cart:updated' (nach DOM-Re-Render),
   'product-ajax:added', 'cart:refresh' und FoxTheme.pubsub 'cart-update'.

   Simulation: ?vip_phase=pre|early|vipday|day2|day3|post (sessionStorage 'vip_phase_sim'; ?vip_phase=off löscht),
   optional ?vip_now=2026-10-25T07:30:00Z – nur wenn theme.role != 'main' (window.VIP_ENV.role).
*/
(function () {
  'use strict';
  if (window.VIP && window.VIP.__core) return;

  var CFG = window.VIP_CONFIG || { phases: [], gift: {}, delivery: {} };
  var ENV = window.VIP_ENV || {};
  var SIM_KEY = 'vip_phase_sim';
  var SIM_NOW_KEY = 'vip_now_sim';
  var PHASE_DEBOUNCE_MS = 1500;
  var canSimulate = String(ENV.role || '').toLowerCase() !== 'main';

  /* ---------- Phasen vorbereiten ---------- */
  var phases = (CFG.phases || []).map(function (p) {
    var o = {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) o[k] = p[k];
    o.startAt = Date.parse(p.start);
    o.endAt = Date.parse(p.end);
    o.tiers = (p.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    return o;
  }).sort(function (a, b) { return a.startAt - b.startAt; });
  // untilAt = exklusive Obergrenze: Start der nächsten Phase, bei der letzten Phase end + 1 s (Sekunde inklusive).
  for (var pi = 0; pi < phases.length; pi++) {
    var nxt = phases[pi + 1];
    phases[pi].untilAt = nxt ? nxt.startAt : (phases[pi].endAt + 1000);
  }
  var first = phases[0], last = phases[phases.length - 1];

  /* ---------- Simulation ---------- */
  function store(k, v) { try { if (v === null || v === undefined) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  var simulated = null, simOffset = 0;
  (function initSim() {
    if (!canSimulate) { store(SIM_KEY, null); store(SIM_NOW_KEY, null); return; }
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { qs = null; }
    if (qs && qs.has('vip_phase')) {
      var v = (qs.get('vip_phase') || '').trim().toLowerCase();
      store(SIM_KEY, (v === '' || v === 'off' || v === 'none' || v === 'live') ? null : v);
    }
    if (qs && qs.has('vip_now')) {
      var n = (qs.get('vip_now') || '').trim();
      store(SIM_NOW_KEY, n === '' || n === 'off' ? null : n);
    }
    var key = load(SIM_KEY);
    var nowSim = load(SIM_NOW_KEY);
    var base = null;
    if (nowSim) {
      var t = Date.parse(nowSim);
      if (!isNaN(t)) base = t;
    }
    if (key) {
      var validKeys = ['pre', 'post'].concat(phases.map(function (p) { return p.key; }));
      if (validKeys.indexOf(key) === -1) { store(SIM_KEY, null); key = null; }
    }
    if (key && base === null) {
      if (key === 'pre' && first) base = first.startAt - 60 * 60 * 1000;
      else if (key === 'post' && last) base = last.untilAt + 60 * 60 * 1000;
      else {
        var ph = phases.filter(function (p) { return p.key === key; })[0];
        if (ph) base = ph.startAt + 1000;
      }
    }
    if (base !== null) {
      simulated = key || 'time';
      simOffset = base - Date.now();
    }
  })();

  function now() { return new Date(Date.now() + simOffset); }

  /* ---------- Phase / Staffel ---------- */
  function phaseAt(ts) {
    for (var i = 0; i < phases.length; i++) {
      if (ts >= phases[i].startAt && ts < phases[i].untilAt) {
        var o = {}; for (var k in phases[i]) o[k] = phases[i][k];
        o.active = true;
        return o;
      }
    }
    if (first && ts < first.startAt) {
      return { key: 'pre', label: 'Vor dem VIP Sale', code: '', start: null, end: first.start, startAt: null, endAt: first.startAt, untilAt: first.startAt, password_only: false, gift: false, tiers: [], active: false };
    }
    return { key: 'post', label: 'VIP Sale beendet', code: '', start: last ? last.end : null, end: null, startAt: last ? last.untilAt : null, endAt: null, untilAt: null, password_only: false, gift: false, tiers: [], active: false };
  }
  function phase() { return phaseAt(now().getTime()); }
  function tiers() { return phase().tiers || []; }
  function tierFor(cents) {
    var eur = (Number(cents) || 0) / 100, t = tiers(), hit = null;
    for (var i = 0; i < t.length; i++) if (eur >= t[i].min) hit = t[i];
    return hit;
  }
  function nextTierFor(cents) {
    var eur = (Number(cents) || 0) / 100, t = tiers();
    for (var i = 0; i < t.length; i++) {
      if (eur < t[i].min) return { min: t[i].min, pct: t[i].pct, missingCents: Math.round((t[i].min - eur) * 100) };
    }
    return null;
  }
  function nextSwitchAt() {
    var p = phase();
    // aktiv: Start der nächsten Phase (bzw. Ende der letzten); pre: Start der ersten Phase; post: kein Wechsel mehr
    if (p.untilAt) return new Date(p.untilAt);
    return null;
  }

  /* ---------- Warenkorb ---------- */
  var giftProp = (CFG.gift && CFG.gift.line_property) || '_vip_gift';
  function isGiftLine(item) {
    return !!(item && item.properties && item.properties[giftProp]);
  }
  function cartBasisCents(cart) {
    cart = cart || VIP.cart;
    if (!cart || !cart.items) return 0;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftLine(it)) continue;
      var line = (typeof it.original_line_price === 'number') ? it.original_line_price : (it.original_price || it.price || 0) * (it.quantity || 0);
      sum += line;
    }
    return sum;
  }
  function formatEUR(cents) {
    var v = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: ENV.currency || 'EUR' }).format(v); }
    catch (e) { return v.toFixed(2).replace('.', ',') + ' €'; }
  }

  function routes() {
    var r = (window.FoxTheme && window.FoxTheme.routes) || {};
    var root = r.root_url || '/';
    if (root.length > 1 && root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return {
      root: root || '',
      cart: r.cart_url || (root + '/cart'),
      add: r.cart_add_url || (root + '/cart/add'),
      change: r.cart_change_url || (root + '/cart/change'),
      update: r.cart_update_url || (root + '/cart/update')
    };
  }
  function jsonFetch(url, opts) {
    opts = opts || {};
    var cfg = { method: opts.method || 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' };
    if (opts.body !== undefined) cfg.body = JSON.stringify(opts.body);
    return window.fetch(url, cfg).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) { var err = new Error(json && (json.description || json.message) || ('HTTP ' + res.status)); err.response = json; throw err; }
        return json;
      });
    });
  }
  function collectSections() {
    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    } catch (e) {}
    return sections.filter(function (s, i, a) { return s && a.indexOf(s) === i; });
  }
  function publishToTheme(cart) {
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        return true;
      }
    } catch (e) { console.warn('[VIP] Theme-Re-Render fehlgeschlagen', e); }
    return false;
  }
  function refreshCart() {
    return jsonFetch(routes().cart + '.js').then(function (cart) { setCart(cart, 'refresh'); return cart; });
  }
  /* Re-Render über das Theme: /cart/update.js mit sections -> FoxTheme.pubsub 'cart-update' -> CartItems.onCartUpdate
     ersetzt #CartDrawerBody/#CartDrawerFooter/#CartDrawerEmpty und #MainCart-… und feuert danach 'cart:updated'. */
  function rerender(opts) {
    opts = opts || {};
    var sections = collectSections();
    var body = {};
    if (opts.payload) for (var k in opts.payload) body[k] = opts.payload[k];
    body.sections = sections;
    body.sections_url = window.location.pathname;
    var url = opts.url || (routes().update + '.js');
    return jsonFetch(url, { method: 'POST', body: body }).then(function (cart) {
      if (cart && cart.items) {
        if (!publishToTheme(cart)) setCart(cart, opts.source || 'rerender');
        if (opts.open) { try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })); } catch (e) {} }
        return cart;
      }
      return refreshCart();
    });
  }
  function updateCart(payload) { return rerender({ payload: payload || {}, source: 'update' }); }
  function changeLine(payload) { return rerender({ payload: payload || {}, url: routes().change + '.js', source: 'change' }); }
  function addItems(payload, opts) {
    var p = payload || {};
    if (p.items === undefined && p.id !== undefined) p = { items: [p] };
    return jsonFetch(routes().add + '.js', { method: 'POST', body: p }).then(function () {
      return rerender({ source: 'add', open: !!(opts && opts.open) });
    });
  }

  /* ---------- Events ---------- */
  var currentPhaseKey = null;
  function emitPhase(prev) {
    var p = phase();
    try { document.dispatchEvent(new CustomEvent('vip:phase', { detail: { phase: p, previous: prev || null, simulated: simulated } })); } catch (e) {}
    document.documentElement.setAttribute('data-vip-phase', p.key);
    document.documentElement.classList.toggle('vip-active', !!p.active);
  }
  var cartTimer = null, lastSig = '', lastSigAt = 0;
  function sig(cart) {
    if (!cart) return '';
    try { return [cart.token, cart.item_count, cart.total_price, cart.original_total_price, (cart.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|'), JSON.stringify(cart.attributes || {})].join('#'); } catch (e) { return String(Date.now()); }
  }
  function emitCart(source) {
    var cart = VIP.cart;
    var basis = cartBasisCents(cart);
    var detail = { cart: cart, basisCents: basis, tier: tierFor(basis), source: source || 'unknown' };
    try { document.dispatchEvent(new CustomEvent('vip:cart', { detail: detail })); } catch (e) {}
    try { document.documentElement.classList.toggle('vip-cart-empty', !cart || !cart.item_count); } catch (e) {}
  }
  function setCart(cart, source, immediate) {
    if (!cart || typeof cart !== 'object' || !('items' in cart)) return;
    VIP.cart = cart;
    var s = sig(cart);
    if (immediate) {
      clearTimeout(cartTimer); cartTimer = null;
      lastSig = s; lastSigAt = Date.now();
      emitCart(source);
      return;
    }
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      cartTimer = null;
      // Unveraenderter Warenkorb (z. B. Nachlade-GETs des Themes) -> kein zweites vip:cart.
      // Nach einem DOM-Re-Render feuert das Theme 'cart:updated' -> immediate-Pfad oben, der immer emittiert.
      if (s === lastSig) return;
      lastSig = s; lastSigAt = Date.now();
      emitCart(source);
    }, 120);
  }

  /* ---------- fetch / XHR abfangen ---------- */
  function cartKind(url) {
    try {
      var u = String(url || '');
      var path = u.indexOf('://') > -1 ? new URL(u, window.location.origin).pathname : u.split('?')[0];
      var m = path.match(/\/cart(?:\/(add|change|update|clear))?\.js$/);
      if (m) return m[1] || 'get';
      m = path.match(/\/cart\/(add|change|update|clear)$/);
      if (m) return m[1];
    } catch (e) {}
    return null;
  }
  function handleCartResponse(kind, text, source) {
    var json = null;
    try { json = JSON.parse(text); } catch (e) { json = null; }
    if (!json) return;
    if (json.items && typeof json.item_count !== 'undefined') { setCart(json, source + ':' + kind); return; }
    // add.js liefert nur die Zeile(n) -> Warenkorb nachladen (das Theme rendert parallel selbst neu)
    if (kind === 'add' || kind === 'clear') setTimeout(function () { refreshCart().catch(function () {}); }, 60);
  }
  if (window.fetch && !window.fetch.__vip) {
    var origFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var kind = cartKind(url);
      var p = origFetch.apply(window, arguments);
      if (!kind) return p;
      return p.then(function (res) {
        try { res.clone().text().then(function (t) { handleCartResponse(kind, t, 'fetch'); }).catch(function () {}); } catch (e) {}
        return res;
      });
    };
    wrapped.__vip = true;
    window.fetch = wrapped;
  }
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__vipPatched) {
    var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__vipKind = cartKind(url); return oOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__vipKind) {
        var kind = this.__vipKind;
        this.addEventListener('loadend', function () { try { if (this.status >= 200 && this.status < 300) handleCartResponse(kind, this.responseText, 'xhr'); } catch (e) {} });
      }
      return oSend.apply(this, arguments);
    };
    XMLHttpRequest.prototype.__vipPatched = true;
  }

  /* ---------- Theme-Events ---------- */
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) setCart(cart, 'theme:cart:updated', true);
    else refreshCart().catch(function () {});
  });
  document.addEventListener('product-ajax:added', function () { setTimeout(function () { if (!cartTimer) refreshCart().catch(function () {}); }, 150); });
  function hookPubsub() {
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && !FoxTheme.pubsub.__vip) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.cart && ev.cart.items) setCart(ev.cart, 'theme:pubsub'); });
        FoxTheme.pubsub.__vip = true;
        return true;
      }
    } catch (e) {}
    return false;
  }

  /* ---------- Abos ---------- */
  function onPhase(fn) { document.addEventListener('vip:phase', function (e) { fn(e.detail.phase, e.detail); }); try { fn(phase(), { phase: phase(), previous: null, simulated: simulated, initial: true }); } catch (e) { console.error('[VIP] onPhase', e); } }
  function onCart(fn) { document.addEventListener('vip:cart', function (e) { fn(e.detail.cart, e.detail); }); if (VIP.cart) { try { var b = cartBasisCents(VIP.cart); fn(VIP.cart, { cart: VIP.cart, basisCents: b, tier: tierFor(b), source: 'initial', initial: true }); } catch (e) { console.error('[VIP] onCart', e); } } }
  function simulate(key) {
    if (!canSimulate) { console.warn('[VIP] Simulation im Live-Theme nicht möglich.'); return; }
    store(SIM_KEY, key || null); store(SIM_NOW_KEY, null);
    try { var u = new URL(window.location.href); u.searchParams.delete('vip_phase'); u.searchParams.delete('vip_now'); window.location.href = u.toString(); } catch (e) { window.location.reload(); }
  }

  var VIP = {
    __core: true,
    config: CFG,
    env: ENV,
    phases: phases,
    cart: null,
    simulated: simulated,
    now: now,
    phase: phase,
    phaseAt: phaseAt,
    tiers: tiers,
    tierFor: tierFor,
    nextTierFor: nextTierFor,
    nextSwitchAt: nextSwitchAt,
    cartBasisCents: cartBasisCents,
    isGiftLine: isGiftLine,
    formatEUR: formatEUR,
    refreshCart: refreshCart,
    rerender: rerender,
    updateCart: updateCart,
    changeLine: changeLine,
    addItems: addItems,
    onPhase: onPhase,
    onCart: onCart,
    simulate: simulate,
    routes: routes
  };
  window.VIP = VIP;

  /* ---------- Start ---------- */
  function boot() {
    hookPubsub() || setTimeout(hookPubsub, 500);
    var p = phase();
    currentPhaseKey = p.key;
    emitPhase(null); // erste Auswertung sofort, ohne Debounce
    // Phasenwechsel-Wächter (alle 500 ms, läuft auch mit simulierter Zeit). Ein Wechsel wird erst gemeldet,
    // wenn die neue Phase PHASE_DEBOUNCE_MS stabil anliegt – kein Flackern durch Jitter (B1-Fix).
    var pendingKey = null, pendingSince = 0;
    setInterval(function () {
      var q = phase();
      if (q.key === currentPhaseKey) { pendingKey = null; return; }
      var t = Date.now();
      if (q.key !== pendingKey) { pendingKey = q.key; pendingSince = t; return; }
      if (t - pendingSince < PHASE_DEBOUNCE_MS) return;
      var prev = currentPhaseKey; currentPhaseKey = q.key; pendingKey = null;
      emitPhase(prev);
    }, 500);
    refreshCart().then(function (cart) {
      var basis = cartBasisCents(cart), t = tierFor(basis);
      console.info('[VIP] Phase: ' + p.key + (p.active ? ' (' + p.label + ', bis ' + new Date(p.endAt).toLocaleString('de-AT', { timeZone: 'Europe/Vienna' }) + ')' : '') +
        (simulated ? ' · SIMULIERT (' + simulated + ')' : '') +
        ' · Staffel: ' + (p.tiers.length ? p.tiers.map(function (x) { return 'ab ' + x.min + ' € → ' + x.pct + ' %'; }).join(' | ') : '–') +
        ' · Warenkorb vor Rabatt: ' + formatEUR(basis) + ' → Stufe: ' + (t ? (t.pct + ' % (ab ' + t.min + ' €)') : '–'));
    }).catch(function (e) { console.warn('[VIP] Warenkorb konnte nicht geladen werden', e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
